const BatchCreate = () => import(/* webpackChunkName: "manager" */ './BatchCreate.vue');

export default {
    routes: [
        {
            path: '/proj/batch_create',
            name: 'BatchCreate',
            component: BatchCreate
        }
    ]
}
